import React from 'react';

interface IconProps {
    color?: string;  // Cor do ícone
    height?: string; // Altura do ícone
}

const FacebookIcon: React.FC<IconProps> = ({ color = "#000000", height = "24" }) => (
    <svg
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m0 0h24v24h-24z" fill="#fff" opacity="0" transform="matrix(-1 0 0 -1 24 24)" />
        <path d="m17 3.5a.5.5 0 0 0 -.5-.5h-2.5a4.77 4.77 0 0 0 -5 4.5v2.7h-2.5a.5.5 0 0 0 -.5.5v2.6a.5.5 0 0 0 .5.5h2.5v6.7a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-6.7h2.62a.5.5 0 0 0 .49-.37l.72-2.6a.5.5 0 0 0 -.48-.63h-3.35v-2.7a1 1 0 0 1 1-.9h2.5a.5.5 0 0 0 .5-.5z" fill={color} />
    </svg>
);

export default FacebookIcon;
